import { createContext, useState, useContext } from 'react';
import LoadingPage from 'components/loading/LoadingPage'

export const LoadingContext = createContext();

export function useLoading() {
   return useContext(LoadingContext)
}

export function LoadingProvider({ children }) {
   const [loading, setLoading] = useState(false);

   return (
      <LoadingContext.Provider value={setLoading}>
         {loading ? (
            <LoadingPage />
         ) : (
            <>
               {children}
            </>
         )}
      </LoadingContext.Provider>
   );
}